import React, { useContext, useEffect, useState } from 'react';
import {
	SectionWrapper,
	Wrapper,
	InsightsWrapper,
	TutorialWrapper,
	TitleWrapper,
	Heading,
	TutrialBackgroundWrapper,
	MapBackgroundWrapper,
	KPIValue,
	KPIText,
	HexagonGrid,
	TextOverlay,
	KPIText2,
	TutorialSection,
	HexagonNumber,
} from './SectionThree.styles';
import MapImg from '../../assets/images/map.png';
import Accordion from 'LandingPage/components/Accordion/Accordion';
import { getSXRStats } from 'utils/apiRequests';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { getCurrencySymbolFromOptions } from 'Investigate/utils';
import { getFormattedSpendWithSymbol } from 'utils/number';
import useScrollToHash from 'Hooks/useScrollToHash';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const SectionThree = () => {
	const [data, setData] = useState({
		statsTotalSpend: 0,
		countNormalizedVendorName: 0,
		countAP_L4Category: 0,
		benchmarkCriticalSpendAreas: 10,
		maxSpend: 0,
		minSpend: 0,
	});
	const [isLoading, setIsLoading] = useState(true);
	const { currency } = useContext(QueryStringContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	useScrollToHash();
	const location = useLocation();
	const openAccordionId = location.state?.openAccordionId || 0;

	useEffect(() => {
		loadStats();
	}, []);

	const loadStats = async () => {
		try {
			const response = await getSXRStats();
			if (response.succeeded) {
				if (response.data !== null) {
					if (Object.keys(response.data).length > 0) {
						setData(response.data);
					}
				}
			} else {
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.log(error);
		}
	};

	const formatValue = num => {
		if (num >= 1e9) {
			return Math.floor(num / 1e9) + 'B';
		} else if (num >= 1e6) {
			return Math.floor(num / 1e6) + 'M';
		} else if (num >= 1e3) {
			return Math.floor(num / 1e3) + 'K';
		} else {
			return num.toString();
		}
	};

	return (
		<SectionWrapper id="stats">
			<Wrapper>
				<InsightsWrapper>
					<TitleWrapper>
						<Heading>Why Choose Spend X-Ray</Heading>
					</TitleWrapper>
					<MapBackgroundWrapper imageUrl={MapImg}>
						{!isLoading && (
							<>
								<HexagonNumber className="hexagon-1">
									<KPIValue>
										{getFormattedSpendWithSymbol(
											data?.statsTotalSpend,
											currencySymbol,
											true
										).toUpperCase()}
									</KPIValue>
									<KPIText>Spend Analyzed</KPIText>
								</HexagonNumber>
								<HexagonNumber className="hexagon-2">
									<KPIText>Database of</KPIText>
									<KPIValue>
										{formatValue(data?.countNormalizedVendorName)}
									</KPIValue>
									<KPIText>Vendors</KPIText>
								</HexagonNumber>
								<HexagonNumber className="hexagon-3">
									<KPIText>Benchmarks for</KPIText>
									<KPIValue>{data?.benchmarkCriticalSpendAreas}+</KPIValue>
									<KPIText>Critical Spend Areas</KPIText>
								</HexagonNumber>
								<HexagonNumber className="hexagon-4">
									<KPIText>Client Spend</KPIText>
									<KPIText>Ranging From</KPIText>
									<KPIValue>
										{getFormattedSpendWithSymbol(
											data?.minSpend,
											currencySymbol,
											true
										).toUpperCase()}
										-
										{getFormattedSpendWithSymbol(
											data?.maxSpend,
											currencySymbol,
											true
										).toUpperCase()}
									</KPIValue>
								</HexagonNumber>

								<HexagonNumber className="hexagon-5">
									<KPIText>Coverage Across</KPIText>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'baseline',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
											}}
										>
											<KPIValue>12</KPIValue>
											<KPIText>Industries</KPIText>
										</div>
										<div>
											<KPIText2>&</KPIText2>
										</div>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
											}}
										>
											<KPIValue>3</KPIValue>
											<KPIText>Regions</KPIText>
										</div>
									</div>
								</HexagonNumber>

								<HexagonNumber className="hexagon-6">
									<KPIText>L4 Classification</KPIText>
									<KPIValue>{data?.countAP_L4Category}+</KPIValue>
								</HexagonNumber>
							</>
						)}
					</MapBackgroundWrapper>
				</InsightsWrapper>
				<TutorialWrapper>
					<TitleWrapper>
						<Heading>How Do I?</Heading>
					</TitleWrapper>
					<TutrialBackgroundWrapper>
						<TutorialSection>
							<Accordion openAccordionId={openAccordionId} />
						</TutorialSection>
					</TutrialBackgroundWrapper>
				</TutorialWrapper>
			</Wrapper>
		</SectionWrapper>
	);
};

export default SectionThree;
